import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IPhenophasesState } from "../shared";

const initialState: IPhenophasesState = {
  selectedIds: [],
  searchText: "",
};

export const phenophasesSlice = createSlice({
  name: "phenophasesUi",
  initialState,
  reducers: {
    setSelectedIdsAction(state, action: PayloadAction<string[]>) {
      state.selectedIds = action.payload;
    },
    toggleId(state, action: PayloadAction<string>) {
      const id = action.payload;
      if (state.selectedIds.includes(id)) {
        state.selectedIds = state.selectedIds.filter((item) => item !== id);
      } else {
        state.selectedIds = [id, ...state.selectedIds];
      }
    },
    setSearchText(state, action: PayloadAction<string>) {
      state.searchText = action.payload;
    },
  },
});

export const { setSelectedIdsAction, toggleId, setSearchText } = phenophasesSlice.actions;

export const phenophasesUiReducer = phenophasesSlice.reducer;
